fragment aliyahDetails on AliyahType {
  id
  rank
  year
  section
  variant
  comment
  user {
    username
  }
}
